<template>
  <div class="mt-2">
    <div class="col-12 p-0">
      <i v-if="archive === true" class="material-icons float-right pr-2" @click="$emit('loadArchive')">refresh</i>
      <h2 class="block-header mb-0" data-toggle="collapse" :href="'#orders_' + name" role="button" aria-expanded="true" :aria-controls="'orders_' + name">
        {{ name }}
      </h2>
    </div>
    <div class="col-12 align-self-center collapse show p-0 table-responsive" :id="'orders_' + name">
      <table class="table table-hover">
        <thead>
          <th>ID</th>
          <th>Дата заявки</th>
          <th style="max-width: 60px;">Дата готовности</th>
          <th>Заказчик</th>
          <th>Комментарий</th>
          <th>Заметка</th>
          <th>Количество</th>
          <th>Категория</th>
          <th>Файлы</th>
          <th style="min-width: 120px;">Статус</th>
          <th></th>
        </thead>
        <tbody>
          <tr v-for="order in orders" :key="'material_' + order.id" class="cursor-pointer" :class="{ 'active' : orderActive.id == order.id }" @click="$emit('orderActiveSet', order)">
            <td>{{ order.id }}</td>
            <td>{{ new Date(order.created_at).toLocaleString('ru-RU') }}</td>
            <td><Datetime v-model="order.ready_at" type="datetime" input-class="form-control" format="dd.MM.yyyy HH:mm" :phrases="{ok: 'Подтвердить', cancel: 'Отменить'}" @close="$set(order, 'changed', true)"/></td>
            <td>{{ order.name }}<br>{{ order.email }}<br>{{ order.phone }}</td>
            <td>{{ order.comment }}</td>
            <td><textarea class="form-control" v-model="order.comment_admin" @input="$set(order, 'changed', true)"></textarea></td>
            <td>{{ order.count }}</td>
            <td>{{ order.configuration ? `${order.configuration.name} ${JSON.stringify(order.configuration.data) !== JSON.stringify(order.data) ? '(изменено)' : ''}` : 'нет' }}</td>
            <td>
              <a class="btn btn-outline-primary" v-for="(attachment, index) in order.attachments" :key="'attachment_' + attachment.id" :href="attachment.file">{{ index + 1 }}</a>
            </td>
            <td>
              <select class="form-control" id="partitions-select" v-model="order.status" @change="$set(order, 'changed', true)">
                <option value="0">Заявка</option>
                <option value="1">Заказ</option>
                <option value="2">Архив</option>
                <option value="-1">Удалить</option>
              </select>
            </td>
            <td v-if="order.changed == true" class="px-1"><i class="material-icons checkbox float-right" @click="$emit('saveOrder', order)">save</i></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Datetime } from 'vue-datetime';
import { Settings } from 'luxon';
Settings.defaultLocale = 'ru';
import 'vue-datetime/dist/vue-datetime.css';
Vue.component('datetime', Datetime);
export default {
  name: "Orders",
  props: {
    archive: Boolean,
    id: String,
    name: String,
    orders: Array,
    orderActive: Object,
  },
  components: {
    Datetime,
  },
}
</script>

<style>
.vdatetime-popup__header, .vdatetime-calendar__month__day--selected > span > span, .vdatetime-calendar__month__day--selected:hover > span > span {
  background-color: var(--darklight);
}
.vdatetime-popup__actions__button {
  color: var(--darklight);
}
</style>
